import { render, staticRenderFns } from "./LabelArchiveMatrix.vue?vue&type=template&id=7caaf864&scoped=true"
import script from "./LabelArchiveMatrix.vue?vue&type=script&lang=js"
export * from "./LabelArchiveMatrix.vue?vue&type=script&lang=js"
import style0 from "./LabelArchiveMatrix.vue?vue&type=style&index=0&id=7caaf864&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7caaf864",
  null
  
)

export default component.exports